import React, { type ReactElement, type ReactNode } from 'react';

import { useConfig } from '../../../../../features/config';
import useTranslation from '../../../../../features/locale/useTranslation';
import { Text } from '../../../../Typography';
import { useSelectRootContext } from '../../root/SelectRootContext';

import styles from './SelectDropdownEmptyContent.module.scss';

type SelectDropdownEmptyContentProps = {
    img?: ReactElement;
    title?: string;
    description?: string;
    start?: ReactNode;
    end?: ReactNode;
    children?: ReactNode;
};

const SelectDropdownEmptyContent = ({
    img,
    title,
    description,
    start,
    end,
    children
}: SelectDropdownEmptyContentProps) => {
    const { t } = useTranslation();
    const { illustrations } = useConfig();

    const mergedTitle = title ?? t('No data');
    const {
        options: { noOptions }
    } = useSelectRootContext();

    if (!noOptions) return null;

    if (children) return children;

    const defaultImg = illustrations?.notFound ? (
        <img src={illustrations.notFound} alt={mergedTitle} />
    ) : null;

    return (
        <div className={styles.container}>
            {start}

            {img || defaultImg ? <div className={styles.img}>{img ?? defaultImg}</div> : null}
            {mergedTitle && (
                <div className={styles.title}>
                    <Text type="h4">{mergedTitle}</Text>
                </div>
            )}
            {description && (
                <div className={styles.description}>
                    <Text>{description}</Text>
                </div>
            )}
            {end}
        </div>
    );
};

export { SelectDropdownEmptyContent };
